module.exports = __webpack_public_path__ + "img/tpcg.321d0873.png";